import { AppIcon } from '@shared-ui/components/ui/app-icon'
import { Loader } from '@shared-ui/components/ui/loader'
import { GText } from '@shared-ui/components/ui/text'
import { useAppTheme } from '@shared-ui/theme'
import type { ReactNode } from 'react'
import { Pressable, type StyleProp, View, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'

export type StatusNoticeProps = {
  children?: ReactNode
  title: string
  description: string
  state: 'pending' | 'cancelled'
  onPress?: () => void
  style?: StyleProp<ViewStyle>
  testID?: string
}

export function StatusNotice({ children, title, description, state, onPress, style, testID }: StatusNoticeProps) {
  const styles = useCreateStyles()
  const theme = useAppTheme()
  const isCancelled = state === 'cancelled'
  return (
    <Pressable
      accessibilityRole={onPress ? 'button' : undefined}
      onPress={onPress}
      testID={testID}
      style={[styles.root, isCancelled && styles.cancelled, style]}
    >
      <View style={[styles.content, isCancelled && styles.cancelledContent]}>
        {!isCancelled && <Loader size={24} color={theme.COLOR_ICON_WARNING} isWithTrack />}
        <View style={[styles.textBlock, isCancelled && styles.cancelledText]}>
          <View style={styles.title}>
            {isCancelled && <AppIcon icon="close-circle" size={24} isDanger />}
            <GText variant="body-16-semibold">{title}</GText>
          </View>
          <GText variant="caption-14-regular" isSecondary>
            {description}
          </GText>
        </View>
        {children}
      </View>
      {!isCancelled && <AppIcon icon="chevron-right" size={20} isSecondary />}
    </Pressable>
  )
}
